<!-- Important messages (site-wide announcements) -->
<ca-important-message></ca-important-message>

<!-- Top-level router outlet - handles login vs. authenticated layout split -->
<router-outlet></router-outlet>

<!-- Command palette — mountováno v app-root (composition root), ne v core/layout,
     aby core nezáviselo na features. Komponenta si sama gateuje zkratky podle auth. -->
<ca-command-palette></ca-command-palette>
